import {ALL_FAMILIES, ALL_SOURCES, BLANK_FAMILY} from 'src/modules/user-settings/constants';
import {getAllSources} from 'src/modules/user-settings/utils/getAllSources';
import {groupCheckedIds} from 'src/modules/user-settings/utils/groupCheckedIds';
import {EventUpdateSubscription} from 'src/openapi/models/EventUpdateSubscription';

export const convertCheckedIdsToEventSubscriptions = (
    checkedIds: string[],
    availableFamilies: string[],
): EventUpdateSubscription[] => {
    const allSources = getAllSources();
    const allFamilies = [BLANK_FAMILY, ...availableFamilies];
    const groupedCheckedIds = groupCheckedIds(checkedIds, allSources, allFamilies);

    const isAllSourcesSelected = Object.keys(groupedCheckedIds).length === allSources.length;
    const isAllFamiliesSelected = Object.values(groupedCheckedIds)
        .every(value => value.families.length === allFamilies.length);

    if (isAllSourcesSelected && isAllFamiliesSelected) {
        return [{source: ALL_SOURCES, families: [ALL_FAMILIES]}];
    }

    return groupedCheckedIds.map(({source, families}) => {
        return {
            source,
            families: families.length === allFamilies.length ? [ALL_FAMILIES] : families,
        };
    });
};
